<template>
  <vx-card style="padding-left: 10px">
    <div class="vx-row flex mb-2">
      <div class="vx-col w-full" align="right">
        <vs-button
          align="right"
          @click="createFranchiseHandler"
          icon-pack="feather"
          icon="icon-edit"
          >Create Doctor Clinic</vs-button
        >
      </div>
    </div>
    <div id="data-list-list-view" class="data-list-container">
      <vs-table
        ref="table"
        :sst="true"
        :total="totalDocs"
        :data="users"
        @search="handleSearch"
        @change-page="handleChangePage"
        @sort="handleSort"
        :max-items="dataTableParams.limit"
        search
        :noDataText="noDataText"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse flex-grow justify-between"
        >
          <div style="float: left">
            <vs-select
              placeholder="10"
              vs-multiple
              autocomplete
              v-model="dataTableParams.limit"
              class="m-2"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in limitOptions"
              />
            </vs-select>
          </div>
        </div>

        <template slot="thead">
          <vs-th sort-key="companyName">Company Name</vs-th>
          <vs-th sort-key="franchiseBusinessName">Business Name</vs-th>
          <vs-th sort-key="abn" v-if="$isAuRegion()">Company ABN</vs-th>
          <vs-th sort-key="address.displayAddress">Street Address</vs-th>
          <vs-th sort-key="postalAddress">Postal Address</vs-th>
          <vs-th sort-key="email">Email</vs-th>
          <vs-th sort-key="status">Status</vs-th>
          <vs-th sort-key="hasApprovedByAdmin">Admin Approval</vs-th>
          <vs-th sort-key="createdAt">Created At</vs-th>
          <vs-th size="25%">Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].companyName">{{
              data[indextr].companyName | capitalize
            }}</vs-td>
            <vs-td :data="data[indextr].franchiseBusinessName">{{
              data[indextr].franchiseBusinessName | capitalize
            }}</vs-td>
            <vs-td :data="data[indextr].abn" v-if="$isAuRegion()">{{
              data[indextr].abn | capitalize
            }}</vs-td>
            <vs-td :data="data[indextr].address.displayAddress">{{
              data[indextr].address.displayAddress | capitalize
            }}</vs-td>
            <vs-td :data="data[indextr].postalAddress">{{
              data[indextr].postalAddress | capitalize
            }}</vs-td>
            <vs-td :data="data[indextr].email">{{ data[indextr].email }}</vs-td>
            <vs-td :data="data[indextr].status">
              <p
                v-if="data[indextr].status === 'Pending_Approval'"
                class="text-sm"
              >
                Pending Approval
              </p>
              <p v-else class="text-sm">{{ data[indextr].status }}</p>
            </vs-td>
            <vs-td>{{ data[indextr].hasApprovedByAdmin }}</vs-td>
            <vs-td :data="data[indextr].createdAt">{{
              data[indextr].createdAt | date_formatter
            }}</vs-td>
            <vs-td :data="data[indextr]._id">
              <vx-tooltip text="View/Edit Details">
                <vs-button
                  type="border"
                  size="small"
                  @click="editDetailHandler(data[indextr]._id)"
                  icon-pack="feather"
                  icon="icon-edit"
                  color="success"
                  class="m-1"
                ></vs-button>
              </vx-tooltip>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="m-2">
        <span class="mr-2">
          {{
            dataTableParams.page * dataTableParams.limit -
            (dataTableParams.limit - 1)
          }}
          -
          {{
            totalDocs - dataTableParams.page * dataTableParams.limit > 0
              ? dataTableParams.page * dataTableParams.limit
              : totalDocs
          }}
          of {{ totalDocs }}
        </span>
        <div class="pagination-div" v-if="serverResponded">
          <paginate
            :page-count="totalPage"
            :click-handler="handleChangePage"
            class="pagination"
            :page-range="9"
            :prevText="'<'"
            :nextText="'>'"
          ></paginate>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'doctor-table',
  props: {
    viewRoute: {
      type: String,
      default: 'FranchiseDoctorEdit',
    },
  },
  data() {
    return {
      noDataText: 'Loading...',
      isMounted: false,
      totalDocs: 0,
      dataTableParams: {
        search: '',
        sort: 'createdAt',
        dir: 'desc',
        page: 1,
        limit: 25,
        filter: 'All',
        activeClinicId: '',
        userType: 'doctorClinic',
      },
      users: [],
      serverResponded: false,
      limitOptions: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 },
        { text: '50', value: 50 },
        { text: '100', value: 100 },
      ],
      filterList: [
        { value: 'All', label: 'All Doctors' },
        { value: 'Active', label: 'Active' },
        { value: 'Disabled', label: 'Disabled' },
      ],
      awaitingSearch: null,
    };
  },
  methods: {
    ...mapActions('clinic', ['fetchDoctorClinics']),
    getFranchiseList() {
      let self = this;
      this.$vs.loading();
      this.fetchDoctorClinics(self.dataTableParams).then((res) => {
        self.users = res.data.data.docs;
        self.totalDocs = res.data.data.pagination.total;
        self.page = res.data.data.pagination.page;
        self.serverResponded = true;
        self.noDataText = 'No franchise available';
        this.$vs.loading.close();
      });
    },
    handleSearch(searching) {
      if (this.awaitingSearch) {
        clearTimeout(this.awaitingSearch);
        this.awaitingSearch = null;
      }
      this.awaitingSearch = setTimeout(() => {
        this.serverResponded = false;
        this.dataTableParams.search = searching;
        this.dataTableParams.page = 1;
        this.$refs.table.currentx = 1;
        this.getFranchiseList();
      }, 500);
    },
    handleChangePage(page) {
      this.dataTableParams.page = page;
      this.getFranchiseList();
    },
    handleSort(key, active) {
      this.serverResponded = false;
      this.dataTableParams.sort = key;
      this.dataTableParams.dir = active;
      this.dataTableParams.page = 1;
      this.$refs.table.currentx = 1;
      this.getFranchiseList();
    },
    editDetailHandler(id) {
      this.$router.push({
        name: 'SuperAdminDoctorClinicsEdit',
        params: { franchiseId: id },
      });
    },
    viewDetailHandler(id, name) {
      this.$router.push({
        name: name,
        params: { franchiseId: id },
      });
    },
    createFranchiseHandler() {
      this.$router.push({ name: 'SuperAdminDoctorClinicsCreate' });
    },
  },
  watch: {
    'dataTableParams.page': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.dataTableParams.page = newVal;
        this.getFranchiseList();
      }
    },
    'dataTableParams.limit': function (newlimit, oldLimit) {
      if (newlimit !== oldLimit) {
        this.serverResponded = false;
        this.dataTableParams.page = 1;
        this.dataTableParams.limit = newlimit;
        this.getFranchiseList();
      }
    },
    'dataTableParams.filter': function (newfilterVal, oldFilterVal) {
      if (newfilterVal !== oldFilterVal) {
        this.dataTableParams.page = 1;
        this.dataTableParams.filter = newfilterVal;
        this.getFranchiseList();
      }
    },
    '$store.state.AppActiveClinicId': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.dataTableParams.activeClinicId = newVal;
        this.getFranchiseList();
      }
    },
  },
  computed: {
    totalPage: function () {
      return this.totalDocs / this.dataTableParams.limit >
        parseInt(this.totalDocs / this.dataTableParams.limit)
        ? parseInt(this.totalDocs / this.dataTableParams.limit) + 1
        : parseInt(this.totalDocs / this.dataTableParams.limit);
    },
  },
  async created() {
    this.dataTableParams.activeClinicId = await this.$store.state
      .AppActiveClinicId;
    this.getFranchiseList();
  },
};
</script>
